import { NgModule } from '@angular/core';
import { ScenarioListComponent } from './scenario-comparison/scenario-list/scenario-list.component';
import { ResultsSidebarComponent } from './results-sidebar/results-sidebar.component';
import { ScenarioResultsComponent } from './scenario-comparison/scenario-results/scenario-results.component';
import { CustomBarComponent } from './results-helper/graph-selector/custom-bar.component';
import { ResultsComponent } from './results.component';
import { GraphSelectorComponent } from './results-helper/graph-selector/graph-selector.component';
import { CommonModule } from '@angular/common';
import { ResultsRoutingModule } from './results-routing.module';
import { SharedModule } from '../helper/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GetNameDialogComponent } from './results-helper/get-name.dialog';
import { NouisliderModule } from 'ng2-nouislider';
import { BaselineInputSummaryComponent } from './baseline/baseline-input-summary/baseline-input-summary.component';
import { BaselineComponent } from './baseline/baseline.component';
import { ScenarioComponent } from './scenario-comparison/scenario.component';
import { CanDeactivateGuard } from '../helper/can-deactivate/can-deactivate.guard';
import { CanDeactivateDialogComponent } from '../helper/can-deactivate/can-deactivate-dialog/can-deactivate-dialog.component';
import { BaselineTechnicalComponent } from './baseline/baseline-technical/baseline-technical.component';
import { BaselineFeedstockBreakdownComponent } from './baseline/baseline-feedstock-breakdown/baseline-feedstock-breakdown.component';
import { BaselineFinancialMetricsComponent } from './baseline/baseline-financial-metrics/baseline-financial-metrics.component';
import { BaselineFinancialGeneralComponent } from './baseline/baseline-financial-general/baseline-financial-general.component';
import { BaselineDebtScheduleComponent } from './baseline/baseline-debt-schedule/baseline-debt-schedule.component';
import { BaselineIncomeStatementComponent } from './baseline/baseline-income-statement/baseline-income-statement.component';
import { BaselineCashFlowAnalysisComponent } from './baseline/baseline-cash-flow-analysis/baseline-cash-flow-analysis.component';
import { BaselineOverviewComponent } from './baseline/baseline-overview/baseline-overview.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { GroupedResultTableComponent } from './results-helper/grouped-result-table/grouped-result-table.component';
import { ScenarioModifyDialogComponent } from './scenario-comparison/scenario-list/scenario-modify-dialog/scenario-modify-dialog.component';
import { SensitivityInputSelectionComponent } from './sensitivity/input-selection/sensitivity-input-selection.component';
import { SensitivityResultGraphComponent } from './sensitivity/sensitivity-result-graph/sensitivity-result-graph.component';
import { SensSimDetailsDialogComponent } from './sensitivity/sensitivity-helper/sens-sim-details-dialog/sens-sim-details-dialog.component';
import { ScenarioComparisonResultsGuard } from './scenario-comparison-results-guard.service';
import { ValidateGuard } from '../project/validate-guard';
import { SensitivityComponent } from './sensitivity/sensitivity.component';
import { ScenarioResultDropdownSearchComponent } from './scenario-comparison/scenario-results/scenario-results-dropdown-search/result-dropdown-search.component';
import { FlowComponent } from './baseline/flow/flow.component';
import { HistoryPickerComponent } from './history-picker/history-picker.component';
import { ResultListDialogComponent } from './history-picker/result-list-dialog/result-list-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { TreetableComponent } from './results-helper/results-treetable/ng-material-treetable/component/treetable.component';
import { ResultsTreetableComponent } from './results-helper/results-treetable/results-treetable.component';
import { BaselineSummaryComponent } from './baseline/baseline-summary/baseline-summary.component';
import { BaselineSummaryDetailedComponent } from './baseline/baseline-summary-detailed/baseline-summary-detailed.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ResultsSummarySaveDialogComponent } from './baseline/baseline-summary/results-summary-save-dialog/results-summary-save-dialog.component';
import { SensitivityAIPopupComponent } from './sensitivity/sensitivity-ai-popup/sensitivity-ai-popup.component';
import { ScenarioItemValidatorDirective } from './scenario-comparison/scenario-list/scenario-modify-dialog/scenario-modify-helper/scenario-item-validator.directive';

@NgModule({
  declarations: [
    ScenarioListComponent,
    ScenarioModifyDialogComponent,
    ResultsSidebarComponent,
    ScenarioResultsComponent,
    ResultsComponent,
    GraphSelectorComponent,
    CustomBarComponent,
    GetNameDialogComponent,
    BaselineInputSummaryComponent,
    BaselineComponent,
    ScenarioComponent,
    BaselineTechnicalComponent,
    BaselineFeedstockBreakdownComponent,
    BaselineFinancialMetricsComponent,
    BaselineFinancialGeneralComponent,
    BaselineDebtScheduleComponent,
    BaselineIncomeStatementComponent,
    BaselineCashFlowAnalysisComponent,
    BaselineOverviewComponent,
    GroupedResultTableComponent,
    SensitivityComponent,
    SensitivityInputSelectionComponent,
    SensitivityResultGraphComponent,
    SensSimDetailsDialogComponent,
    ScenarioResultDropdownSearchComponent,
    FlowComponent,
    HistoryPickerComponent,
    ResultListDialogComponent,
    TreetableComponent,
    ResultsTreetableComponent,
    BaselineSummaryComponent,
    BaselineSummaryDetailedComponent,
    ResultsSummarySaveDialogComponent,
    SensitivityAIPopupComponent
  ],
  imports: [
    CommonModule,
    ResultsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatTableModule,
    MatIconModule,
    NgxChartsModule,
    NgxMatSelectSearchModule,
    NouisliderModule,
    MatSelectModule,
    MatSlideToggleModule,
    NgxChartsModule,
    MatTooltipModule,
    TranslateModule,
    MatProgressSpinnerModule,
    ScenarioItemValidatorDirective
  ],
  exports: [],
  providers: [
    CanDeactivateDialogComponent,
    CanDeactivateGuard,
    ScenarioComparisonResultsGuard,
    ValidateGuard,
  ]
})
export class ResultsModule {}
